<!--
/**
 * 表单属性设置组件
 * version: 1.0
 * author: lybbn
 * program django-vue-lyadmin
 * email: 1042594286@qq.com
 * website: http://www.lybbn.cn
 * date: 2022.12.17
 * remark: 如果要分发django-vue-lyadmin源码或其中组件等，需在本文件顶部保留此文件头信息！！！
 */
-->
<template>
    <div class="lysp-main">
        <el-tabs v-model="activeTab" stretch>
            <el-tab-pane name="lyfirst" label="组件属性">
                <el-scrollbar class="lysp-scrow" :style="{height: scrollerHeight}">
                    <template v-if="!!builderStore.selectedWidget">
                        <component :is="getWidgetSettingName(selectedWidget)" :key="selectedWidget.id" :selected-widget="selectedWidget" :option-model="optionModel" :builderConfig="builderConfig"></component>
                    </template>
                    <template v-if="Object.keys(builderStore.selectedWidget).length==0">
                        <el-empty class="ly-empty-text" description="请选择组件" />
                    </template>
                </el-scrollbar>
            </el-tab-pane>
            <el-tab-pane name="lytwo" label="表单属性">
                <el-scrollbar class="lysp-scrow" :style="{height: scrollerHeight}">
                    <lyFormSetting :form-config="formConfig" :builderConfig="builderConfig"></lyFormSetting>
                </el-scrollbar>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script setup>
    import {ref, onMounted, reactive, nextTick, onBeforeUnmount, watch, computed} from 'vue'
    import { useBuilderStore } from "@/store/lyFormBuilder";
    import lyFormSetting from '@/components/lyform-builder/lysetting-pannel/lyFormSetting'

    const props = defineProps({
        isFull:{
            type:Boolean,
            default:false
        },
        selectedWidget: Object,
        formConfig: Object,
        height:{ type:String, default:"auto" },//设计器高度，auto自动
        builderConfig :{
            type:Object,
            default:{
                showHeader:true,//是否显示头部信息
                showFormTemplates:true,//是否显示表单模板
                showEventCollapse:true,//是否显示组件事件属性折叠面板
                showDocumentButton:true,//是否显示文档按钮
                clearDesignerButton: true,  //是否显示清空设计器按钮
                previewFormButton: true,  //是否显示预览表单按钮
                exportJsonButton: true,  //是否显示导出JSON器按钮
                exportCodeButton: true,  //是否显示导出代码按钮
                importJsonButton:true, //是否显示导入代码按钮
                showFullButton: true,  //是否显示全屏按钮
                openNewWindowButton: true,  //是否显示新窗口按钮
                saveFormButton:true, //是否保存表单按钮
                showCrudSettings:true,//是否显示组件和表单的crud属性配置
            }
        },
     })

    const builderStore = useBuilderStore()

    const optionModel = computed({
        get:()=> {
            return props.selectedWidget.options
        },
        set:(n)=> {
            props.selectedWidget.options = n
        }
    })

    let activeTab = ref("lytwo")

    function getWidgetSettingName(selectedWidget) {
        return selectedWidget.type + '-setting-ly'
    }

    let scrollerHeight = ref(0)

    watch(()=>props.height,(newVal, oldVal)=>{
        calcDesignBodyHeight()
    })
    function calcDesignBodyHeight(){
        let headerheight = props.builderConfig.showHeader?49:0
        if(props.isFull){
            scrollerHeight.value = window.innerHeight - 40 - headerheight  + 'px'
        }else{
            if(props.height !='auto'){
                scrollerHeight.value = (parseInt(props.height) - 40 - headerheight)+ 'px'
            }else{
                scrollerHeight.value = window.innerHeight - 153 - headerheight + 'px'
            }
        }
    }

    function lyHandleResize(){
        nextTick(() => {
            calcDesignBodyHeight()
        })
    }
    watch(() => props.isFull, (n) => {
        lyHandleResize()
    })
    onMounted(()=>{
        if (!builderStore.selectedWidget) {
            activeTab.value = "lytwo"
        } else {
            activeTab.value = "lyfirst"
        }
        lyHandleResize()
        window.addEventListener('resize',lyHandleResize)
    })
    onBeforeUnmount(() => {
        window.removeEventListener('resize',lyHandleResize)
    })

</script>

<style lang="scss" scoped>
    .lysp-main{
        .lysp-scrow{
            padding: 0 8px 0 8px;
            background:var(--l-changetab-bg);
            ::v-deep(.el-scrollbar__wrap) {
                overflow-x: hidden;
            }
            ::v-deep(.el-scrollbar__view){
                margin-bottom: 30px;
            }
        }
        .el-tabs{
            ::v-deep(.el-tabs__header) {
                margin:0;
                background:var(--l-changetab-bg);
            }
        }
        .ly-empty-text{
            margin-top: 30px;
        }
       ::v-deep(.el-form-item--small){
           margin-bottom: 10px;
       }
    }

</style>